import { api } from '../../../api/axios'

// pecas comuns das abas do IPSC

export const cartao = 'bg-compumaq-pretoSuave rounded-xl border border-compumaq-dourado/25 shadow-sm'
export const th = 'text-left px-3 py-2 font-medium text-compumaq-textoSuave whitespace-nowrap'
export const td = 'px-3 py-2'
export const btnPrimario = 'px-4 py-2 bg-compumaq-dourado text-compumaq-texto text-sm rounded-lg hover:bg-compumaq-doradoClaro disabled:opacity-50'
export const btnSecundario = 'px-4 py-2 border border-compumaq-dourado/40 text-compumaq-texto text-sm rounded-lg hover:bg-compumaq-preto disabled:opacity-50'

// mensagem de erro da API (as rotas do IPSC devolvem `error`; detalhes do zod em `details`)
export function erroApi(err: any, padrao: string): string {
  const d = err?.response?.data
  const campos = d?.details?.fieldErrors ? Object.values(d.details.fieldErrors).flat().join('; ') : ''
  const form = d?.details?.formErrors?.join?.('; ') ?? ''
  return [d?.error ?? d?.message ?? padrao, campos || form].filter(Boolean).join(': ')
}

export async function baixarPdf(url: string, arquivo: string) {
  const r = await api.get(url, { responseType: 'blob' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(r.data as Blob)
  link.download = arquivo
  link.click()
  setTimeout(() => URL.revokeObjectURL(link.href), 5000)
}

export const n4 = (v: number | string | null | undefined) =>
  v == null ? '—' : Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })
export const n2 = (v: number | string | null | undefined) =>
  v == null ? '—' : Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
